<template>
  <q-btn-dropdown
    :split="!!isHeader"
    :stack="!!isHeader"
    flat
    :label="isHeader && this.$q.screen.gt.md ? $t('names.options') : null"
    icon="settings"
    v-model="showDropdownOptions"
    @click="clickOptions"
  >
    <q-list>
      <panorama-campaigns-dropdown v-if="isMenu" :isHeader="isHeader" :isMenu="true"/>
      <q-separator v-if="isMenu" />
      <slot name="before"></slot>
      <q-item
        v-close-popup
        clickable
        :disable="!latLng"
        @click="activatePannellum"
      >
        <q-item-section avatar>
          <q-avatar icon="panorama"/>
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ showPannellum ? $t('tools.panorama.disablePano') : $t('tools.panorama.enablePano') }}</q-item-label>
          <q-item-label caption>{{ $t('tools.panorama.enablePanoDescription') }}</q-item-label>
        </q-item-section>
      </q-item>
      <q-item
        clickable
        :disable="!latLng"
        v-close-popup
        @click="activatePotree"
      >
        <q-item-section avatar>
          <q-avatar icon="terrain"/>
        </q-item-section>
        <q-item-section>
          <q-item-label>{{ showPotree ? $t('tools.panorama.disable3D') : $t('tools.panorama.enable3D') }}</q-item-label>
          <q-item-label caption>{{ $t('tools.panorama.enable3DDescription') }}</q-item-label>
        </q-item-section>
      </q-item>
      <slot name="after"></slot>
    </q-list>
  </q-btn-dropdown>
</template>

<script>
import { mapState } from 'vuex'
import proj4 from 'proj4'
import { ClosePopup, QAvatar, QBtnDropdown, QList, QItem, QItemLabel, QItemSection, QSeparator } from 'quasar'

import { projections } from 'src/lib/projections'
import { calculateTargetPoint } from 'src/lib/geometry'
import PanoramaCampaignsDropdown from 'components/Panorama/PanoramaCampaignsDropdown.vue'

export default {
  props: ['isHeader', 'isMenu'],
  data () {
    return {
      showDropdownOptions: false
    }
  },
  components: {
    PanoramaCampaignsDropdown, QAvatar, QBtnDropdown, QList, QItem, QItemLabel, QItemSection, QSeparator
  },
  directives: {
    ClosePopup
  },
  computed: {
    ...mapState({
      latLng: state => state.panorama.latLng,
      head: state => state.panorama.head,
      altitude: state => state.panorama.altitude,
      showPannellum: state => state.panorama.showPannellum,
      showPotree: state => state.panorama.showPotree,
      srcPannellum: state => state.panorama.srcPannellum,
      srcPotree: state => state.panorama.srcPotree
    })
  },
  methods: {
    activatePannellum () {
      const isActive = this.$store.state.panorama.showPannellum
      this.$store.commit('panorama/setShowPannellum', !isActive)
    },
    activatePotree () {
      const isActive = this.$store.state.panorama.showPotree
      this.$store.commit('panorama/setShowPotree', !isActive)
    },
    clickOptions () {
      if (this.isHeader) {
        this.showDropdownOptions = !this.showDropdownOptions
      }
    },
    openPano () {
      if (this.srcPannellum) {
        window.open(this.srcPannellum)
      }
    },
    openPointCloud () {
      if (this.srcPotree) {
        proj4.defs(projections)
        const latLngProj = proj4('EPSG:4326', `EPSG:${this.$config.panoramas.epsg}`).forward([this.latLng.lng, this.latLng.lat])
        const latLngTarget = calculateTargetPoint(latLngProj, this.head, 100)
        const params = `&position=${latLngProj[0]},${latLngProj[1]},${this.altitude}&lookat=${latLngTarget[0]},${latLngTarget[1]},${this.altitude}&lydlg=true`
        window.open(this.srcPotree + params)
      }
    }
  }
}
</script>
